import { FlexCol, FlexRow } from '@/components/common/Flex';
import Icon from '@/components/common/icons/Icon';
import { Paragraph } from '@/components/common/Typography';
import { Text } from '@chakra-ui/react';
import { IconName } from '@common/react/icons';

const FEATURE_LIST: { iconName: IconName; text: string }[] = [
    {
        iconName: 'BarChart08',
        text: 'Customizable budgeting tools that adapt to your spending habits',
    },
    {
        iconName: 'Percent03',
        text: `Personalized insights based on your last 3 months of spending`,
    },
    {
        iconName: 'LineChartUp02',
        text: 'Compare spending with couples like you by zip code and income',
    },
    {
        iconName: 'Scales01',
        text: 'Collaboration tools to budget and save together effortlessly',
    },
    {
        iconName: 'PiggyBank01',
        text: 'Track progress and set goals for each spending category',
    },
];

const PlentyFeatureListBudgeting = () => (
    <>
        <Paragraph fontWeight="medium" mt={8}>
            Your membership unlocks all these benefits and more:
        </Paragraph>
        <FlexCol gap={5} mt={6}>
            {FEATURE_LIST.map(({ iconName, text }) => (
                <FlexRow key={text} align="center" gap={4}>
                    <Icon name={iconName} color="blue.500" />
                    <Text fontWeight="medium" fontSize="sm">
                        {text}
                    </Text>
                </FlexRow>
            ))}
        </FlexCol>
    </>
);

export default PlentyFeatureListBudgeting;
